import * as RadixPopover from '@radix-ui/react-popover';
import type { ComponentPropsWithRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './Popover.module.scss';

/**
 * Поповер — всплывающая панель с произвольным содержимым: выбор даты,
 * фильтр, выбор исполнителя. От меню отличается тем, что внутри не список
 * действий, а форма.
 *
 * Обёртка над Radix: клавиатура, фокус и позиционирование — его, вид — наш.
 */
export const Popover = RadixPopover.Root;
export const PopoverTrigger = RadixPopover.Trigger;
export const PopoverAnchor = RadixPopover.Anchor;
export const PopoverClose = RadixPopover.Close;

export type PopoverContentProps = ComponentPropsWithRef<typeof RadixPopover.Content>;

export function PopoverContent({
  className,
  sideOffset = 6,
  collisionPadding = 8,
  ...rest
}: PopoverContentProps) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        className={cx(styles['popover'], className)}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        {...rest}
      />
    </RadixPopover.Portal>
  );
}
